import React from 'react';
import InsideNavHeader from './InsideNavHeader';
import TrialEndedBanner from '../../../components/kea/TrialEndedBanner/TrialEndedBanner';

/**
 * Horizontal — normal app surface shell with fixed top nav.
 *
 * Render contract (04-layout-navigation-and-containers-v1.md — Normal App Surface):
 * - Fixed top horizontal navigation always visible.
 * - Wizard and auth surfaces are routed BEFORE AppLayout in App.js,
 *   so this component never renders for those surfaces.
 * - Menu visibility is not tied to wizard/welcome page detection here.
 */
const Horizontal = ({ children }) => (
  <>
    <style>{`
      .app-header-horizontal {
        min-height: 64px !important;
        height: 64px !important;
      }
    `}</style>
    <div className="app-container app-compact">
      <div className="app-main-container">
        <div className="app-header app-header-horizontal" data-testid="app-top-nav">
          <InsideNavHeader />
        </div>
        <TrialEndedBanner />
        <main className="app-main-content-wrapper">
          <div className="app-main-content">
            {children}
          </div>
        </main>
      </div>
    </div>
  </>
);

export default Horizontal;
